import React, { useContext } from 'react';
import { SearchList } from '../SearchList/SearchList';
import { useAppSelector } from '../../../../../redux/store.model';
import { isLoadingStructure } from '../../../../../redux/structure/selectors/Structure.selector';
import { useParams } from 'react-router-dom';
import { SearchContext } from '../SearchBar';
import { getAllRegions } from '../../../../../redux/structure/selectors/Region.selector';

export const RegionSearch = () => {
  const { search } = useContext(SearchContext);
  const searchQuery = search.toLowerCase();
  const { marketId } = useParams<{ marketId: string }>();

  const regions = useAppSelector((state) =>
    getAllRegions(state, { workspaceId: marketId })
  );
  const isLoading = useAppSelector((state) =>
    isLoadingStructure(state, { workspaceId: marketId })
  );

  const filteredRegions =
    regions
      ?.filter((region) => region.name?.toLowerCase().includes(searchQuery))
      .map((item) => {
        return { ...item, key: item.id ?? '', value: item.name ?? '' };
      }) ?? [];

  return (
    <SearchList
      header="initial_setup.region_label"
      list={filteredRegions}
      loading={isLoading}
    />
  );
};
